import { InitFeatureParams } from '../types'

import { getRoutes } from './routes'

/**
 * 资讯热点模块注册
 *
 * @param param0 - props
 * @param param0.addRoutes - 添加路由
 */
export const initHotNews = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
